export enum CloneOptions {
    Groups = 1,
    Filters,
    SendDate,
    SmsMarketing,
    Pulses,
    Random,
    SupportedForBee
}